angular.module('jv.candidate.details.workflow.interview.scheduler.controller', ['jv.calendarFactory', 'ngAnimate'])
.controller('jvCandidateDetailsWorkflowInterviewSchedulerController', ['$scope', 'candidates', '$rootScope', '$routeParams','$localStorage', '$window', '$location', '$filter', 'jvCalendarFactory', 'jvInterviewService', '$log',
    function($scope, candidates, $rootScope, $routeParams, $localStorage, $window, $location, $filter, jvCalendarFactory, jvInterviewService, $log) {

    if(!$rootScope.miniHeader || !$rootScope.miniHeader.show){
        $rootScope.miniHeader = {
            show: true,
            back: 'workflow/'+$routeParams.applicationId
        };
    }

    jvCalendarFactory.setCurrentCalInstance('scheduler-calendar');
    jvCalendarFactory.setDatePickerInstance('#scheduler-datepicker');

    var USERS = {};
    var MEETING_ROOMS = [];
    var ENTITY_ID_NAME = {};
    var ENTITY_NAME = {};
    var TIMEZONE = $window._jvselfUser.locale.timezone;
    var REQUESTED_TIME_SLOTS_DAYS = {};
    var RESTORED_EVENTS_DATES = [];
    // TIMEKEEPER is used to keep track of maxslots for each unique event and
    // jvId which is used to help determine if a user is allowed to move a requested time slot.
    var TIMEKEEPER = {};
    var FREEBUSY_QUERY_TRACKER = {};
    var i = 0;
    var MAX_DAYS = 10;
    var MEETING_ROOMS_CHECK = 0;
    var MEETING_ROOMS_DEFAULT = {
        rooms: [],
        added: null,
        removed: null
    };
    $scope.intGroups = [];
    $scope.flags.loading=false;

    $scope.scheduler = {};

    $scope.scheduler.showDialog = false;
    $scope.scheduler.loading = [];
    $scope.scheduler.allTimezones = $window.timezones;
    $scope.scheduler.mode = 'REQUEST';
    $scope.scheduler.interviewersExpand = true;
    $scope.scheduler.overrideInterviewDuration = 0;
    $scope.scheduler.selectedTimezone = $filter('filter')($scope.scheduler.allTimezones, {'openSysId': TIMEZONE})[0];
    $scope.scheduler.selectedInterviewDuration = '30';
    $scope.scheduler.overallSlotCount = 0;
    // Auto-Schedule OFF by default
    $scope.scheduler.auto = false;
    // Disables the ability to toggle Auto-Schedule ON/OFF
    $scope.scheduler.autoDisabled = true;
    $scope.scheduler.meetingroomBlock = false;
    $scope.scheduler.request = {};
    $scope.scheduler.meetingRoomEnabled = false;
    $scope.scheduler.meetingRooms = angular.copy(MEETING_ROOMS_DEFAULT);
    $scope.scheduler.minimumCandTimeslot = '1';
    $scope.scheduler.enableSMSDelivery = false;

    $scope.videoConferencingProperties = {};
    $scope.videoConferencingProperties.includeConferenceLink = jvInterviewService.getIncludeConferenceLink();
    $scope.enableSMSMessaging = false;
    $scope.enableSMSToggle = false;
    var addLoading = function(loader){
        $scope.scheduler.loading.push(loader);
        $scope.flags.loading = true;
    };

    var removeLoading = function(loader){
        $scope.scheduler.loading.splice($scope.scheduler.loading.indexOf(loader), 1);
        if($scope.scheduler.loading.length === 0){
            $scope.flags.loading = false;
        }
    };

    var init = function(){
        if (typeof $localStorage.schedulerAuto === 'undefined') {
            $localStorage.schedulerAuto = false;
        }

        if (typeof $localStorage.enableSMSMessaging === 'undefined') {
            $localStorage.enableSMSMessaging = false;
        }

        if (typeof $localStorage.enableSMSToggle === 'undefined') {
            $localStorage.enableSMSToggle = false;
        }

        if (typeof $localStorage.enableSMSDelivery === 'undefined') {
            $localStorage.enableSMSDelivery = false;
        }

        $scope.scheduler.auto = $localStorage.schedulerAuto;
        $scope.scheduler.enableSMSDelivery = $localStorage.enableSMSDelivery;

        if($scope.scheduler.mode === 'REQUEST'){
            addLoading('InterviewInfo');
            addLoading('CandidateInfo');
            var data = {
                applicationId: $routeParams.applicationId,
                readMode: 1
            };

            candidates.getApplicationDetails($routeParams.applicationId, $.param(data, true), function(appResponse){
                removeLoading('CandidateInfo');
                if(appResponse.application.job && appResponse.application.job.workflowEId){
                    $scope.workflowEId = appResponse.application.job.workflowEId;
                }
                $scope.appDetails = angular.copy(appResponse);
                $localStorage.appDetails = angular.copy(appResponse);
            });

            data = {
                readMode: 1,
                selfSchedule: true
            };

            candidates.getSchedule($routeParams.applicationId, $routeParams.stateId, data, function(response){
                removeLoading('InterviewInfo');
                if(response.interviewSchedule &&
                        response.interviewSchedule.model &&
                        response.interviewSchedule.model.isLocationEnabled){
                    $scope.scheduler.meetingRoomEnabled = true;
                }
                if (response.calendarInfo.showOutlookCalendarFreeBusy ||
                    response.calendarInfo.hasGoogleCalendarSetup ||
                    response.calendarInfo.microsoftOfficeGraphIntegration) {
                    // Enables the ability to toggle Auto-Schedule ON/OFF

                     $scope.scheduler.autoDisabled = false;
                     if (typeof $localStorage.autoSchedularFirstTime === 'undefined') {
                         $localStorage.autoSchedularFirstTime = true;
                         $scope.scheduler.auto = true;
                     }

                    for (var key in $scope.scheduler.calendarLegends) {
                        if($scope.scheduler.calendarLegends[key].legendIf !== true) {
                            $scope.scheduler.calendarLegends[key].legendIf = true;
                        }
                    }
                }

                if ($scope.scheduler.autoDisabled) {
                     $scope.scheduler.auto = false;
                }

                if(response.interviewSchedule && response.interviewSchedule.model) {
                    $scope.videoConferencingProperties.videoConferenceEnabled = response.interviewSchedule.model.videoConferenceEnabled;
                }

                $scope.enableSMSMessaging = response.enableSMSMessaging ? response.enableSMSMessaging : false;
                $scope.enableSMSToggle =  $scope.enableSMSMessaging && response.enableSMSToggle ? response.enableSMSToggle : false;
                $scope.scheduler.enableSMSDelivery = !$scope.enableSMSToggle ? false : $scope.scheduler.enableSMSDelivery;
            });
        }
    };

    var getCalendarDateRange = function() {
        var view = $('#scheduler-calendar').fullCalendar('getView');
        return {
            start: angular.copy(view.start).day(0),
            end: angular.copy(view.start).day(6)
        };
    };

    var formatFreeBusyEvents = function(freeBusyInfo, type) {
        var events = [];
        for (var i in freeBusyInfo) {
            for (var j in freeBusyInfo[i]) {
                var classNames = ['free-busy', 'border-radius-x-large', type, freeBusyInfo[i][j].status];
                if ((type === 'location' && $scope.scheduler.calendarLegends.location.modelDefault) || (type === 'user' && $scope.scheduler.calendarLegends.user.modelDefault)) {
                    classNames.push('opacity-4');
                }
                events.push({
                    jvId: i,
                    className: classNames,
                    title: ENTITY_ID_NAME[i].toUpperCase(),
                    jvName: ENTITY_NAME[i],
                    start: new Date(freeBusyInfo[i][j].fromDateString),
                    end: new Date(freeBusyInfo[i][j].toDateString)
                });
            }
        }
        return events;
    };

    var removeEId = function(eId, idType) {
        var freeBusyKeys = Object.keys(FREEBUSY_QUERY_TRACKER);
        var i = 0;
        for (i in freeBusyKeys) {
            FREEBUSY_QUERY_TRACKER[freeBusyKeys[i]][idType].splice(FREEBUSY_QUERY_TRACKER[freeBusyKeys[i]][idType].indexOf(eId), 1);
        }
    };

    var clearMeetingRoomFreeBusy = function () {
        $scope.scheduler.meetingRooms = angular.copy(MEETING_ROOMS_DEFAULT);
        jvCalendarFactory.removeEvent(function(event){
            if (MEETING_ROOMS.indexOf(event.jvId) > -1) {
                removeEId(event.jvId, 'locationId');
                return true;
            } else {
                return false;
            }
        }, true);
        MEETING_ROOMS = [];
    };

    var clearUsersFreeBusy = function(index) {
        var users = $scope.scheduler.interviewersList[index].users.employees;
        var userIds = [];
        for (i = 0; i < users.length; i++) {
            if(users[i].email !== '') {
                USERS[users[i].EId].count -= 1;
                if (USERS[users[i].EId].count === 0) {
                    userIds.push(users[i].EId);
                    removeEId(users[i].EId, 'userId');
                    delete USERS[users[i].EId];
                }
            }
        }
        if (userIds.length > 0) {
            jvCalendarFactory.removeEvent(function(event){
                return userIds.indexOf(event.jvId) > -1 ? true:false;
            }, true);
        }

    };

    var meetingRoomCheck = function() {
        if (MEETING_ROOMS_CHECK > 0) {
            $scope.scheduler.meetingroomBlock = true;
        } else {
            $scope.scheduler.meetingroomBlock = false;
            clearMeetingRoomFreeBusy();
        }
        $scope.sendRequestDisabled();
    };

    var addEvents = function(eIds, idType){
        var dateRange = getCalendarDateRange();
        var filteredEIds = angular.copy(eIds);
        if (!FREEBUSY_QUERY_TRACKER[dateRange.start.format('YYYY-MM-DD') + ' - ' + dateRange.end.format('YYYY-MM-DD')]) {
            FREEBUSY_QUERY_TRACKER[dateRange.start.format('YYYY-MM-DD') + ' - ' + dateRange.end.format('YYYY-MM-DD')] = {};
        }
        if (!(idType in FREEBUSY_QUERY_TRACKER[dateRange.start.format('YYYY-MM-DD') + ' - ' + dateRange.end.format('YYYY-MM-DD')])) {
            // When adding a new user or room the eIds passed are only the ones to be added.
            // When updating the view all current eIds are passed
            // The following is done so the only the necessary queries are performed
            FREEBUSY_QUERY_TRACKER[dateRange.start.format('YYYY-MM-DD') + ' - ' + dateRange.end.format('YYYY-MM-DD')][idType] = idType === 'userId' ? Object.keys(USERS) : angular.copy(MEETING_ROOMS);
        } else {
            filteredEIds = filteredEIds.filter(function(eId){
                return FREEBUSY_QUERY_TRACKER[dateRange.start.format('YYYY-MM-DD') + ' - ' + dateRange.end.format('YYYY-MM-DD')][idType].indexOf(eId) < 0;
            });
            FREEBUSY_QUERY_TRACKER[dateRange.start.format('YYYY-MM-DD') + ' - ' + dateRange.end.format('YYYY-MM-DD')][idType] = idType === 'userId' ? Object.keys(USERS) : angular.copy(MEETING_ROOMS);
        }

        if (idType === 'userId' && filteredEIds && filteredEIds.length > 0) {
            addLoading('userFreeBusy');
            candidates.gCalEvents($scope.serializeArray(filteredEIds, idType), dateRange.start.format('YYYY-MM-DD'), dateRange.end.add(1, 'day').format('YYYY-MM-DD'), $scope.scheduler.selectedTimezone.id, function(response){
                removeLoading('userFreeBusy');
                var newEvents = formatFreeBusyEvents(response.freeBusyInfo, response.type);
                jvCalendarFactory.addEventSources('scheduler-calendar', newEvents);
            });
        } else if (idType === 'locationId' && filteredEIds && filteredEIds.length > 0){
            addLoading('locationFreeBusy');
            candidates.gCalEventsResource($scope.serializeArray(filteredEIds, idType), dateRange.start.format('YYYY-MM-DD'), dateRange.end.add(1, 'day').format('YYYY-MM-DD'), $scope.scheduler.selectedTimezone.id, function(response){
                removeLoading('locationFreeBusy');
                var newEvents = formatFreeBusyEvents(response.freeBusyInfo, response.type);
                jvCalendarFactory.addEventSources('scheduler-calendar', newEvents);
            });
        }

    };

    var getRequestedAvailabilitySlots = function(){
        return jvCalendarFactory.getCalendarEventsByFilter(function(itm){
                return itm.jvId === 'requested-availability' ? true : false;
            });
    };

    var updateCandidateTimeslots = function(newTimezone, oldTimezone){
        var events = getRequestedAvailabilitySlots();

        var newEvents = [];
        for(i=0; i<events.length; i++){
            var event = events[i];
            var startStr = event.start.format();
            var endStr = event.end.format();

            // converting start end times twice so that it can ignore the calendar timezone
            // calendar time zone cannot be set to user default, it only uses either UTC or browser default
            // We are using browser default
            event.start = moment.tz(moment.tz(startStr, 'YYYY-MM-DDTHH:mm:ss', oldTimezone.openSysId), newTimezone.openSysId).format('YYYY-MM-DDTHH:mm:ss');
            event.end = moment.tz(moment.tz(endStr, 'YYYY-MM-DDTHH:mm:ss', oldTimezone.openSysId), newTimezone.openSysId).format('YYYY-MM-DDTHH:mm:ss');

            delete event._id;
            delete event.source;
            newEvents.push(angular.copy(event));
        }

        jvCalendarFactory.removeEvent(function(itm){
            return itm.jvId === 'requested-availability' ? true : false;
        }, true);

        jvCalendarFactory.addEventSources('scheduler-calendar', newEvents);
    };

    var updateEvents = function(){
        if ($scope.scheduler.interviewersList.length > 0) {
            addEvents(Object.keys(USERS), 'userId');
        }
        if (MEETING_ROOMS.length > 0) {
            addEvents(MEETING_ROOMS, 'locationId');
        }
    };

    var updateEventsTimezone = function(){
        var requestedTimeSlots = $('#scheduler-calendar').fullCalendar('clientEvents',function(itm){
            return itm.jvId === 'requested-availability' ? true : false;
        });

        jvCalendarFactory.resetCalendar('scheduler-calendar');
        FREEBUSY_QUERY_TRACKER = {};

        if ($scope.scheduler.interviewersList.length > 0) {
            addEvents(Object.keys(USERS), 'userId');
        }
        if (MEETING_ROOMS.length > 0) {
            addEvents(MEETING_ROOMS, 'locationId');
        }
        jvCalendarFactory.addEventSources('scheduler-calendar', requestedTimeSlots);
    };

    var createRequestSlot = function(date, duration) {

        var event = {
                jvId: 'requested-availability',
                jvDateKey: date.format('YYYY-MM-DD'),
                jvEventId: moment().format('x'),
                start: date.format(),
                end: date.add(duration, 'minutes').format(),
                className: ['requested-availability', 'border-radius-x-large'],
                editable: true,
                durationEditable: true
         };

        if (event.jvDateKey in REQUESTED_TIME_SLOTS_DAYS) {
            REQUESTED_TIME_SLOTS_DAYS[event.jvDateKey] += 1;
        } else {
            REQUESTED_TIME_SLOTS_DAYS[event.jvDateKey] = 1;
        }

        return event;
    };

    var updateRequestedTimeSlotsDays = function (event, newDateKey) {
        if (TIMEKEEPER[event.jvEventId].prev !== newDateKey) {
            if (!(newDateKey in REQUESTED_TIME_SLOTS_DAYS)) {
                REQUESTED_TIME_SLOTS_DAYS[newDateKey] = 1;
                REQUESTED_TIME_SLOTS_DAYS[TIMEKEEPER[event.jvEventId].prev] -= 1;
            } else if (newDateKey in REQUESTED_TIME_SLOTS_DAYS && newDateKey !== TIMEKEEPER[event.jvEventId].prev) {
                REQUESTED_TIME_SLOTS_DAYS[newDateKey] += 1;
                REQUESTED_TIME_SLOTS_DAYS[TIMEKEEPER[event.jvEventId].prev] -= 1;
            }
            if (REQUESTED_TIME_SLOTS_DAYS[newDateKey] === 0){
                delete REQUESTED_TIME_SLOTS_DAYS[newDateKey];
            } else if (REQUESTED_TIME_SLOTS_DAYS[TIMEKEEPER[event.jvEventId].prev] === 0){
                delete REQUESTED_TIME_SLOTS_DAYS[TIMEKEEPER[event.jvEventId].prev];
            }
            TIMEKEEPER[event.jvEventId].prev = newDateKey;
        }
    };

    var maxTimeSlots = function(eventDurationMinutes) {
        var eventDurationHours = eventDurationMinutes / 60;
        var candidateHours = 0;
        var multiplier = 2;
        if ($scope.scheduler.interviewersList.length === 0) {
            candidateHours = $scope.scheduler.selectedInterviewDuration / 60;
        } else {
            candidateHours = $scope.scheduler.overrideInterviewDuration / 60;
        }

        if (eventDurationMinutes < 30 || candidateHours === 0.25) {
            multiplier = 4;
        }
        var result = Math.floor(((eventDurationHours - candidateHours) * multiplier) + 1);
        return result;
    };

    var updateTimeKeeper = function(event) {
        var newDateKey = event.start.format('YYYY-MM-DD');
        var eventMins = moment.duration(event.end - event.start).asMinutes();
        var maxTimeSlotsForEvent = maxTimeSlots(eventMins);
        if (!(event.jvEventId in TIMEKEEPER)) {
            TIMEKEEPER[event.jvEventId] = {
                prev: event.jvDateKey,
                maxSlots: maxTimeSlotsForEvent
            };
        } else {
            $scope.scheduler.overallSlotCount -= TIMEKEEPER[event.jvEventId].maxSlots;
            TIMEKEEPER[event.jvEventId].maxSlots = maxTimeSlotsForEvent;
        }
        updateRequestedTimeSlotsDays(event, newDateKey);
        $scope.scheduler.overallSlotCount += maxTimeSlotsForEvent;
    };

    var restoreMeetingRoomsEvents = function(meetingRooms){
        for(var i=0; i<meetingRooms.length;i++){
            if (meetingRooms[i].email !== '') {
                MEETING_ROOMS.push(meetingRooms[i].EId);
                ENTITY_ID_NAME[meetingRooms[i].EId] = meetingRooms[i].name[0];
                ENTITY_NAME[meetingRooms[i].EId] = meetingRooms[i].name;
            }
        }
        addEvents(MEETING_ROOMS,'locationId');
    };

    var restoreUserEvents = function(index, users){
        var restoredUsers = [];
        for(i=0; i<users.length; i++){
            if(!USERS[users[i].EId]) {
                USERS[users[i].EId] = users[i];
                restoredUsers.push(users[i].EId);
                ENTITY_ID_NAME[users[i].EId] = (users[i].firstName ? users[i].firstName[0]:'') + (users[i].lastName ? users[i].lastName[0]: '');
                ENTITY_NAME[users[i].EId] = (users[i].firstName ? users[i].firstName:'') +' '+ (users[i].lastName ? users[i].lastName: '');
             }
        }
        addEvents(restoredUsers, 'userId');
    };


    var restoreEvents = function(events, interviewersList, meetingRooms){
        // all the dates with the events which need to be rendered, in order for the state to restore
        if (events && events.length > 0) {
              for (var i=0; i<events.length; i++) {
                var date = events[i].start.format('MM/DD/YYYY');
                if(!RESTORED_EVENTS_DATES[date]) {
                    RESTORED_EVENTS_DATES[date] = {};
                }
                RESTORED_EVENTS_DATES[date][events[i].jvEventId] = true;

                if (events[i].jvDateKey in REQUESTED_TIME_SLOTS_DAYS) {
                    REQUESTED_TIME_SLOTS_DAYS[events[i].jvDateKey] += 1;
                } else {
                    REQUESTED_TIME_SLOTS_DAYS[events[i].jvDateKey] = 1;
                    }
                }
        }
        jvCalendarFactory.addEventSources('scheduler-calendar', events);
        if (interviewersList && interviewersList.length > 0) {
            for (var j=0;j<interviewersList.length;j++) {
                $scope.addInterviewerList();
                $scope.scheduler.interviewersList[j] = interviewersList[j];
                if ($scope.scheduler.interviewersList[j].meetingroom) {
                    $scope.checkedMeetingRoom(j,$scope.scheduler.interviewersList[j].meetingroom);
                    }
                if(interviewersList[j].users.employees && interviewersList[j].users.employees.length > 0){
                    restoreUserEvents(j,interviewersList[j].users.employees);
                }
                $scope.changeDuration();
                $scope.modifiedOrder();
                }
            }
        if(meetingRooms.rooms && meetingRooms.rooms.length > 0){
            $scope.scheduler.meetingRooms = meetingRooms;
            restoreMeetingRoomsEvents(meetingRooms.rooms);
        }
    };

    var restoreRequestAvailabilityState = function() {
        if ($scope.scheduler.mode === 'REQUEST') {
        var requestAvailabilityRestoreState = jvInterviewService.getRequestAvailabilityRestoreState();
        jvInterviewService.clearRequestAvailabilityRestoreState();
        if (requestAvailabilityRestoreState) {
            $scope.scheduler.selectedInterviewDuration = requestAvailabilityRestoreState.selectedInterviewDuration? requestAvailabilityRestoreState.selectedInterviewDuration: $scope.scheduler.selectedInterviewDuration;
            $scope.scheduler.selectedDate = requestAvailabilityRestoreState.selectedDate? requestAvailabilityRestoreState.selectedDate: $scope.scheduler.selectedDate;
            var interviewersList = requestAvailabilityRestoreState.interviewersList;
            var events = requestAvailabilityRestoreState.events;
            var meetingRooms = requestAvailabilityRestoreState.meetingRooms;
            var oldTimezone = $scope.scheduler.selectedTimezone;
            $scope.scheduler.selectedTimezone = requestAvailabilityRestoreState.selectedTimezone? requestAvailabilityRestoreState.selectedTimezone: $scope.scheduler.selectedTimezone;
            $scope.changeTimezone(requestAvailabilityRestoreState.selectedTimezone,oldTimezone);
            $scope.scheduler.calendarLegends.location.modelDefault = requestAvailabilityRestoreState.hideMeetingRooms;
            $scope.scheduler.calendarLegends.user.modelDefault = requestAvailabilityRestoreState.hideInterviewers;
            restoreEvents(events,interviewersList,meetingRooms);
            }
        }
    };

    var customApply = function(){
        var phase = $scope.$$phase;
        if (phase === null) {
            $scope.$apply();
        }
    };

    var deleteEvent = function(event) {
        var newDateKey = event.start.format('YYYY-MM-DD');
        var eventMins = moment.duration(event.end - event.start).asMinutes();
        jvCalendarFactory.removeEvent(event._id, true);
        REQUESTED_TIME_SLOTS_DAYS[newDateKey] -= 1;
        delete TIMEKEEPER[event.jvEventId];
        if (REQUESTED_TIME_SLOTS_DAYS[newDateKey] === 0){
            delete REQUESTED_TIME_SLOTS_DAYS[newDateKey];
        }
        $scope.scheduler.overallSlotCount -= maxTimeSlots(eventMins);
        // Executing apply again here because this happens after eventAfterAllRender
        customApply();
    };

    var changeOpacity = function(classSelector){
        var opacityClass = 'opacity-4';
        var updatedEvents = [];
        var events = jvCalendarFactory.getCalendarEventsByFilter(function(itm){
            return itm.className.includes(classSelector) ? true : false;
        });

        for(var event in events) {
           if (events[event].className.includes(opacityClass)) {
               events[event].className.splice(events[event].className.indexOf(opacityClass), 1);
           } else {
               events[event].className.push(opacityClass);
           }
           updatedEvents.push(events[event]);
        }
        if(updatedEvents.length > 0){
            jvCalendarFactory.updateEvents(updatedEvents);
        }
    };

    var highlightDatepicker = function(){
        var events = getRequestedAvailabilitySlots();
        var dateTimes = [];
        var dates = [];
        angular.forEach(events, function(event){
            dateTimes.push(new Date(event.start.format('MM/DD/YYYY')).getTime());
            dates.push(new Date(event.start.format('MM/DD/YYYY')));
        });
        jvCalendarFactory.updateDatePickerArr(dateTimes);
        jvCalendarFactory.addDateToDatePicker(dates);
        jvCalendarFactory.addClassToDates();
    };

    $scope.serializeArray = function(arr, name, result){
        result = result || [];
        angular.forEach(arr, function(value){
            result.push({name:name, value:value});
        });
        return result;
    };

    $scope.closeMiniHeader = function() {
        $scope.redirectIfNoUnsavedData();
    };

    $scope.scheduler.candTimeslots = [];
    for(i=1; i<=50; i++){
        $scope.scheduler.candTimeslots.push({text: i.toString(), id: i.toString(), value: i});
    }

    if(jvInterviewService.getCandTimeslots() && jvInterviewService.getCandTimeslots() !== 1){
        $scope.scheduler.minimumCandTimeslot = jvInterviewService.getCandTimeslots();
    }

    $scope.scheduler.baseOrder = [
        {text: $scope.i18n['ANY'], id: 'ANY', value: 'any'},
        {text: $scope.i18n['FIRST'], id: 'FIRST', value: 'first'},
        {text: $scope.i18n['LAST'], id: 'LAST', value: 'last'}
    ];

    $scope.scheduler.baseDuration = angular.copy(jvInterviewService.getBaseDuration());

    $scope.scheduler.datepickerOptions = {
        multiSelect: true,
        dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        showOtherMonths: true
    };

    $scope.scheduler.calendarLegends = {
        'busy': {
            legendText: $scope.i18n['NOT_AVAILABLE'],
            legendKeyClass:'float-left',
            legendClass: 'border-radius-x-large busy',
            legendCheckbox: false,
            legendIf: false
        },
        'tentative': {
            legendText: $scope.i18n['TENTATIVE_TIME'],
            legendKeyClass:'float-left',
            legendClass: 'border-radius-x-large tentative',
            legendCheckbox: false,
            legendIf: false
        },
        'location': {
            legendText: $scope.i18n['HIDE_MEETING_ROOMS'],
            legendKeyClass:'float-right border-radius-x-large location',
            legendClass: 'location',
            legendCheckbox: true,
            legendIf: false,
            modelDefault: false,
            action: function() {
                changeOpacity('location');
             }
        },
         'user': {
             legendText: $scope.i18n['HIDE_INTERVIEWERS'],
             legendKeyClass:'float-right border-radius-x-large user',
             legendClass: 'user',
             legendCheckbox: true,
             legendIf: false,
             modelDefault: false,
             action: function() {
                 changeOpacity('user');
             }
         }
    };

    $scope.scheduler.calendarOptions = {
        defaultView: (function(){
            var requestAvailabilityRestoreState = jvInterviewService.getRequestAvailabilityRestoreState();
            return (requestAvailabilityRestoreState && requestAvailabilityRestoreState.defaultView) ?
            requestAvailabilityRestoreState.defaultView
              : 'agendaDay';
        }()),
        columnHeaderHtml: function(mom) {
            var view = $('#scheduler-calendar').fullCalendar('getView');
            var today = moment();
            var name = view.name;
            var orangeFont='';
            if(today.date() === mom.date()
                    && today.month() === mom.month()
                    && today.year() === mom.year()){
                orangeFont = 'orange';
            }

            if(name === 'agendaDay'){
                return '<span class="font-light '+orangeFont+'">'+mom.format('dddd, MMM DD')+'</span>';
            } else if(name === 'agendaWeek'){
                return '<span class="dark-tri font-light '+orangeFont+'">'+mom.format('ddd')+'</span><br/><span class="'+orangeFont+'">' + mom.format('MMM DD')+'</span>';
            }
        },
        scrollTime: '08:00:00',
        slotDuration: '00:15:00',
        slotLabelInterval: '01:00',
        height: 650,
        header: {
            left: '',
            center: '',
            right: 'agendaDay,agendaWeek prev,next'
        },
        buttonText: {
            day: $scope.i18n['DAY'],
            week: $scope.i18n['WEEK']
        },
        buttonIcons: {
            prev: 'icon-arrow-3-left',
            next: 'icon-arrow3'
        },
        dayClick: function(date) {
            var requestedDays = Object.keys(REQUESTED_TIME_SLOTS_DAYS).length;
            var event = {};
            if (requestedDays >= MAX_DAYS && !(date.format('YYYY-MM-DD') in REQUESTED_TIME_SLOTS_DAYS)) {
                return;
            }

            if ($scope.scheduler.overrideInterviewDuration <= 0) {
                event = createRequestSlot(date, $scope.scheduler.selectedInterviewDuration);
                jvCalendarFactory.addEventSources('scheduler-calendar', [event]);
            } else {
                event = createRequestSlot(date, $scope.scheduler.overrideInterviewDuration);
                jvCalendarFactory.addEventSources('scheduler-calendar', [event]);
            }
        },
        viewRender: function() {
            $('.fc-bg.fc-short').hide();

            updateEvents();
            restoreRequestAvailabilityState();
        },
        eventRender: function(event, element) {
            if (event.jvId === 'requested-availability') {
                var eventRestoreKey = event.start.format('MM/DD/YYYY');
                updateTimeKeeper(event);
                element.siblings('.fc-bg, .fc-resizer, .remove-event').remove();
                var bg = $('<div class="fc-bg"></div>');
                var resizer = $('<div class="fc-resizer fc-end-resizer"></div>');
                element.first().append( '<i class="remove-event icon icon-cross regular padding-none"></i>' );
                element.first().append(bg);
                element.first().append(resizer);
                element.find('.remove-event').on('click', function() {
                    deleteEvent(event);
                });
                //to make sure, all the events are rendered and thus overallSlotCount value is correct and send request button is enabled
                if(RESTORED_EVENTS_DATES[eventRestoreKey] && RESTORED_EVENTS_DATES[eventRestoreKey][event.jvEventId]){
                     delete RESTORED_EVENTS_DATES[eventRestoreKey][event.jvEventId];
                }
                if(RESTORED_EVENTS_DATES[eventRestoreKey] && Object.keys(RESTORED_EVENTS_DATES[eventRestoreKey]).length === 0){
                    delete RESTORED_EVENTS_DATES[eventRestoreKey];
                }
                var keys = Object.keys(RESTORED_EVENTS_DATES);
                if(keys.length !== 0){
                    $scope.scheduler.selectedDate = keys[0];

                }
            } else {
                if(event.jvName){
                    element[0].title = event.jvName;
                }
            }
        },
        eventAfterAllRender: function() {
            $('.fc-event-container').children('.fc-bg').remove();
            highlightDatepicker();
            customApply();
        },
        displayEventTime: true,
        timeFormat: 'h(:mm)t',
        eventAllow: function(dropLocation, event) {
            var requestedDays = Object.keys(REQUESTED_TIME_SLOTS_DAYS).length;
            var eventMins = moment.duration(event.end - event.start).asMinutes();

            // prevent extending an event across multiple days
            if (dropLocation.start.format('YYYY-MM-DD') !== dropLocation.end.format('YYYY-MM-DD')) {
                return false;
            }

            // preventing user to reduce the time slot to be less than the 'candidate interview duration'
            if ($scope.scheduler.overrideInterviewDuration <= 0) {
                if(eventMins < $scope.scheduler.selectedInterviewDuration) {
                    return false;
                }
            } else {
                if(eventMins < $scope.scheduler.overrideInterviewDuration) {
                    return false;
                }
            }

            if(requestedDays >= MAX_DAYS){

                if(REQUESTED_TIME_SLOTS_DAYS[dropLocation.start.format('YYYY-MM-DD')] && REQUESTED_TIME_SLOTS_DAYS[dropLocation.start.format('YYYY-MM-DD')] > 0){
                    return true;
                }
                // allows movement if event is the last event in the day and new day doesn't have any events.
                if(!REQUESTED_TIME_SLOTS_DAYS[dropLocation.start.format('YYYY-MM-DD')] &&
                    REQUESTED_TIME_SLOTS_DAYS[TIMEKEEPER[event.jvEventId].prev] === 1){
                    return true;
                }
                return false;
            }
            return true;
        }
    };

    $scope.scheduler.interviewersList = [];

    $scope.checkedMeetingRoom = function(index, meetingroom) {
        if (meetingroom) {
            MEETING_ROOMS_CHECK += 1;
        } else {
            MEETING_ROOMS_CHECK -= 1;
        }
        meetingRoomCheck();
    };

    $scope.sendRequestDisabled = function() {
        var user = false;

        if ($scope.scheduler.overallSlotCount < $scope.scheduler.minimumCandTimeslot || typeof($scope.scheduler.minimumCandTimeslot) === 'undefined') {
            return true;
        }
        if ($scope.scheduler.auto) {
            for (i = 0; i < $scope.scheduler.interviewersList.length; i++) {
                if (($scope.scheduler.interviewersList[i].meetingroom || $scope.videoConferencingProperties.includeConferenceLink) &&
                    $scope.scheduler.interviewersList[i].users.employees.length === 0) {
                    return true;
                }
                if ($scope.scheduler.interviewersList[i].users.employees.length > 0) {
                    user =  true;
                }
            }
            if (user) {
                if (($scope.scheduler.meetingroomBlock &&
                     $scope.scheduler.meetingRooms.rooms &&
                     $scope.scheduler.meetingRooms.rooms.length > 0) || !$scope.scheduler.meetingroomBlock) {
                    return false;
                }
            }
            return true;
        }
        return false;
    };

    $scope.changeDuration = function(){
        $scope.scheduler.overrideInterviewDuration = 0;
        for(i=0; i< $scope.scheduler.interviewersList.length; i++){
            $scope.scheduler.overrideInterviewDuration += parseInt($scope.scheduler.interviewersList[i].duration);
        }
        $scope.updateInterviewDuration($scope.scheduler.overrideInterviewDuration);
    };

    $scope.removeInterviewersList = function(index){
        clearUsersFreeBusy(index);

        if ($scope.scheduler.interviewersList[index].meetingroom) {
            MEETING_ROOMS_CHECK -= 1;
            meetingRoomCheck();
        }
        var deletedSchedule = $scope.scheduler.interviewersList.splice(index,1);
        $scope.scheduler.overrideInterviewDuration -= parseInt(deletedSchedule[0].duration);

        $scope.modifiedOrder();

        if($scope.scheduler.overrideInterviewDuration === 0){
            $scope.updateInterviewDuration($scope.scheduler.selectedInterviewDuration);
        }

        // updating 'Request Availability' button by counting the slots again
        var events = getRequestedAvailabilitySlots();

        for(i=0; i<events.length; i++){
            updateTimeKeeper(events[i]);
        }
    };

    $scope.addInterviewerList = function(){
        var interviewSlot = {
            users:{
                employees: [],
                added: null,
                removed: null
            },
            duration: '30',
            order:'ANY',
            meetingroom: false
        };

        // initialize interview details list
        if($scope.scheduler.overrideInterviewDuration === 0 && parseInt($scope.scheduler.selectedInterviewDuration) <= 480 ){
            // Adding duration in first interviewer slot, we override interview slot with the selectedInterviewDuration
            interviewSlot.duration = $scope.scheduler.selectedInterviewDuration;
            $scope.scheduler.overrideInterviewDuration += parseInt($scope.scheduler.selectedInterviewDuration);
        } else{
            $scope.scheduler.overrideInterviewDuration += 30;
        }

        $scope.scheduler.interviewersList.push(interviewSlot);
        $scope.updateInterviewDuration($scope.scheduler.overrideInterviewDuration);
    };

    $scope.switchToSchedule = function(){
        $scope.scheduler.mode = 'SCHEDULE';
    };

    $scope.switchToRequest = function(){
        $scope.scheduler.mode = 'REQUEST';
        $scope.scheduler.interviewersExpand = true;
    };

    $scope.modifiedOrder = function() {
        var hasFirst = false;
        var hasLast = false;

        for(i=0; i<$scope.scheduler.interviewersList.length; i++){
            if($scope.scheduler.interviewersList[i].order === 'FIRST'){
                hasFirst = true;
            } else if($scope.scheduler.interviewersList[i].order === 'LAST'){
                hasLast = true;
            }
        }

        $scope.scheduler.baseOrder.splice(1, 1, {text: $scope.i18n['FIRST'], id: 'FIRST', value: 'first', disabled: hasFirst});
        $scope.scheduler.baseOrder.splice(2, 1, {text: $scope.i18n['LAST'], id: 'LAST', value: 'last', disabled: hasLast});
    };

    $scope.modifiedInterviewers = function(index, users) {
        if (users.added && users.added.email !== '') {
            if(!USERS[users.added.EId]) {
                USERS[users.added.EId] = users.added;
                USERS[users.added.EId].count = 1;
            } else {
                USERS[users.added.EId].count += 1;
            }
            ENTITY_ID_NAME[users.added.EId] = (users.added.firstName ? users.added.firstName[0]: '') + (users.added.lastName ? users.added.lastName[0] : '');
            ENTITY_NAME[users.added.EId] = (users.added.firstName ? users.added.firstName: '') +' '+ (users.added.lastName ? users.added.lastName : '');
            addEvents([users.added.EId], 'userId');
        }
        if (users.removed && users.removed.email !== '') {
            USERS[users.removed.EId].count -= 1;
            if (USERS[users.removed.EId].count === 0) {
                removeEId(users.removed.EId, 'userId');
                delete USERS[users.removed.EId];
                jvCalendarFactory.removeEvent(function(event){
                    return users.removed.EId === event.jvId ? true:false;
                }, true);
            }
        }
    };

    $scope.updateInterviewDuration = function(newDuration){
        var updatedEvents = [];
        var events = getRequestedAvailabilitySlots();

        for(i=0; i<events.length; i++){
            var event = events[i];
            var eventMins = moment.duration(event.end - event.start).asMinutes();

            if(parseInt(newDuration) > eventMins){
                event.end = moment(event.start).add(parseInt(newDuration), 'minutes');
                updatedEvents.push(event);
            } else {
                updateTimeKeeper(event);
            }
        }

        if(updatedEvents.length > 0){
            jvCalendarFactory.updateEvents(updatedEvents);
        }
    };

    var sendRequest = function() {
        $location.path('/scheduler/request/'+$routeParams.applicationId+'/'+$routeParams.stateId);
    };

    var pushToArrayIfNotExist = function(interviewers, interviewer) {
        var exists = $.map(interviewers, function(val) {
            return val.EId === interviewer.EId ? interviewer.EId : null;
        });

        if(exists[0] !== interviewer.EId) {
            interviewers.push(interviewer);
        }
        return interviewers;
    };

    $scope.reviewRequest = function() {
        $scope.scheduler.request = {};
        $scope.scheduler.request.slots = {};
        var i,j = 0;
        var requestAvailabilityRestoreState = {};
        var duration = 0;
        var events = getRequestedAvailabilitySlots().sort($rootScope.sortObjArrayByProperty('start'));
        var interviewerBlock = [];
        var interviewers = [];

        if ($scope.scheduler.interviewersList.length === 0) {
            duration = $scope.scheduler.selectedInterviewDuration;
        } else {
            duration = $scope.scheduler.overrideInterviewDuration;
        }

        for (i = 0; i < events.length; i++) {
            var key = events[i].start.format('YYYY-MM-DD');
            var prevStart = moment.tz(events[i].start.format('YYYY-MM-DD HH:mm'),'YYYY-MM-DD HH:mm', $scope.scheduler.selectedTimezone.openSysId);
            var prevEnd = moment.tz(events[i].end.format('YYYY-MM-DD HH:mm'),'YYYY-MM-DD HH:mm', $scope.scheduler.selectedTimezone.openSysId);

            if (!$scope.scheduler.request.slots[key]) {
                $scope.scheduler.request.slots[key] = {
                    times: [],
                    interviewDetails: angular.copy($scope.scheduler.interviewersList),
                    meetingrooms: angular.copy($scope.scheduler.meetingRooms)
                };
            }

            $scope.scheduler.request.slots[key].times.push({
                start: angular.copy(prevStart),
                end: angular.copy(prevEnd)
            });
        }

        for(i=0; i< $scope.scheduler.interviewersList.length; i++){
            if($scope.scheduler.interviewersList[i].users && $scope.scheduler.interviewersList[i].users.employees){
                for(j=0; j< $scope.scheduler.interviewersList[i].users.employees.length; j++){
                    $scope.scheduler.interviewersList[i].users.employees[j].userEId = $scope.scheduler.interviewersList[i].users.employees[j].EId;

                    var user = $scope.scheduler.interviewersList[i].users.employees[j];
                    if($scope.videoConferencingProperties.includeConferenceLink && j===0) {
                        user.isHost = true;
                    }

                    interviewers = pushToArrayIfNotExist(interviewers, user);
                }

                var interviewBlockData = {
                    interviewers: $scope.scheduler.interviewersList[i].users.employees,
                    duration: $scope.scheduler.interviewersList[i].duration,
                    order: $scope.scheduler.interviewersList[i].order,
                    requiresMeetingRoom: $scope.scheduler.interviewersList[i].meetingroom,
                    host: $scope.scheduler.interviewersList[i].users.employees[0] ? $scope.scheduler.interviewersList[i].users.employees[0].EId : null,
                    useVC: $scope.videoConferencingProperties.includeConferenceLink
                };

                interviewerBlock.push(interviewBlockData);
            }
        }

        $scope.scheduler.request.totalSlots = $scope.scheduler.minimumCandTimeslot;
        $scope.scheduler.request.totalDuration = duration;
        $scope.scheduler.request.minimumCandTimeslot = $scope.scheduler.minimumCandTimeslot;
        $scope.scheduler.request.auto = $scope.scheduler.auto;
        $scope.scheduler.request.timezone = $scope.scheduler.selectedTimezone;
        $scope.scheduler.request.meetingRooms = $scope.scheduler.meetingRooms.rooms;
        $scope.scheduler.request.interviewerBlock = interviewerBlock;
        $scope.scheduler.request.useVC = $scope.videoConferencingProperties.includeConferenceLink;
        $scope.scheduler.request.enableSMSMessaging = $scope.enableSMSMessaging;
        $scope.scheduler.request.enableSMSToggle = $scope.enableSMSMessaging && $scope.enableSMSToggle;
        $scope.scheduler.request.enableSMSDelivery = $scope.enableSMSToggle && $scope.scheduler.enableSMSDelivery;

        jvInterviewService.saveSchedulerSlots($scope.scheduler.request);
        jvInterviewService.saveInterviewers(interviewers);
        jvInterviewService.saveIncludeConferenceLink($scope.videoConferencingProperties.includeConferenceLink);
        jvInterviewService.saveVideoConferenceEnabled($scope.videoConferencingProperties.videoConferenceEnabled);

        requestAvailabilityRestoreState = {
            selectedInterviewDuration: angular.copy($scope.scheduler.selectedInterviewDuration),
            selectedTimezone: angular.copy($scope.scheduler.selectedTimezone),
            selectedDate: angular.copy($scope.scheduler.selectedDate),
            events: events,
            interviewersList: angular.copy($scope.scheduler.interviewersList),
            meetingRooms: angular.copy($scope.scheduler.meetingRooms),
            defaultView: $('#scheduler-calendar').fullCalendar('getView').name,
            hideInterviewers: angular.copy($scope.scheduler.calendarLegends.user.modelDefault),
            hideMeetingRooms: angular.copy($scope.scheduler.calendarLegends.location.modelDefault),
            useVC: $scope.videoConferencingProperties.includeConferenceLink,
            enableSMSMessaging: $scope.enableSMSMessaging,
            enableSMSToggle: $scope.enableSMSMessaging && $scope.enableSMSToggle
        };

        jvInterviewService.saveRequestAvailabilityRestoreState(requestAvailabilityRestoreState);

        if($scope.videoConferencingProperties.includeConferenceLink) {
            $scope.checkInterviewersVideoConferencingAccount();
        } else {
            sendRequest();
        }
    };

    $scope.checkInterviewersVideoConferencingAccount = function() {
        if($scope.scheduler.interviewersList.length > 0) {
            var hostEIds = [];
            for(i=0; i< $scope.scheduler.interviewersList.length; i++){
                if($scope.scheduler.interviewersList[i].users && $scope.scheduler.interviewersList[i].users.employees && $scope.scheduler.interviewersList[i].users.employees.length > 0){
                   hostEIds.push($scope.scheduler.interviewersList[i].users.employees[0].EId);
                }
            }
            if(hostEIds.length > 0) {
                candidates.checkInterviewersVideoConferencingAccount($routeParams.applicationId, {userEIds: hostEIds}, function(res){
                    if(res && res.nonExistingAccounts && res.nonExistingAccounts.length > 0) {
                        $scope.flags.loading = false;
                        $scope.videoConferencingProperties.showError = true;
                        $scope.videoConferencingProperties.users = res.nonExistingAccounts.join(', ');
                    } else {
                        sendRequest();
                    }
                }, function(fail){
                    $log.error(fail);
                });
            } else {
                sendRequest();
            }
        } else {
            sendRequest();
        }
    };

    $scope.redirectIfNoUnsavedData = function() {
        $scope.scheduler.showDialog = false;
        var url = $window.jvUrls.jhire;
        url += '/modules/candidates/search.html?{0}#/{1}'.format($.param({ mode: 'paginate'}, true),'workflow/{0}/{1}'.format($routeParams.applicationId, $routeParams.stateId));
        $window.location.href = url;
        // $scope.$parent.closeMiniHeader();
    };

    $scope.hideUnsavedDataWarningDialog = function() {
       $scope.scheduler.showDialog = false;
    };

    $scope.checkForUnsavedData = function() {
       if($scope.scheduler.mode === 'REQUEST') {
            var events = getRequestedAvailabilitySlots();
            if ((!$scope.scheduler.meetingRooms || $scope.scheduler.meetingRooms.rooms.length === 0)
            && (Object.keys(USERS).length === 0)
            && (!events || events.length === 0)) {
                $scope.redirectIfNoUnsavedData();
            } else {
                $scope.scheduler.showDialog = true;
            }
        }
    };

    $scope.modifiedMeetingRooms = function(newVal) {
        if ($scope.scheduler.meetingRooms.rooms) {
            if (newVal.added && newVal.added.email !== '') {
                MEETING_ROOMS.push(newVal.added.EId);
                ENTITY_ID_NAME[newVal.added.EId] = newVal.added.name[0];
                ENTITY_NAME[newVal.added.EId] = newVal.added.name;
                addEvents([newVal.added.EId], 'locationId');
            }
            if (newVal.removed && newVal.removed.email !== '') {
                MEETING_ROOMS.splice(MEETING_ROOMS.indexOf(newVal.removed.EId), 1);
                removeEId(newVal.removed.EId, 'locationId');
                jvCalendarFactory.removeEvent(function(event){
                    return newVal.removed.EId === event.jvId ? true:false;
                }, true);
            }
        }
    };

    $scope.saveCandTimeslots = function(newVal) {
        jvInterviewService.saveCandTimeslots(newVal);
    };

    $scope.$watch('scheduler.selectedDate', function(newVal){
        if(newVal){
            var date = moment(newVal);
            jvCalendarFactory.jumpToDate(date);
        }
    });

    $scope.changeTimezone = function(newVal, oldVal){
        updateEventsTimezone();
        updateCandidateTimeslots(newVal, oldVal);
    };

    $scope.formatTimezone = function(data){
        if(data.localizedName){
            var pattern = '\\((.*?)\\)';
            return data.localizedName.match(new RegExp(pattern))[0];
        }
        return '';
    };

    $scope.$watch('scheduler.auto', function(newVal){
        if (newVal && $scope.scheduler.interviewersList.length === 0) {
            $scope.addInterviewerList();
        }
        $localStorage.schedulerAuto = newVal;
    });

    $scope.$watch('scheduler.enableSMSDelivery', function(newVal){
        $localStorage.enableSMSDelivery = newVal;
    });

    init();
}]);
